import { ClassroomSourceType, ClassroomType } from "types/classrooms";

const providerDisplayText = {
	// Synced sources
	azure: "Azure",
	classlink: "ClassLink",
	clever: "Clever",
	ldap: "LDAP",
	oneroster: "OneRoster",
	wonde: "Wonde",
	powerschool: "PowerSchool",

	// Local sources
	local: "Local",
	csv: "CSV",
	combined: "Combined",
};

export const getProviderDisplayText = (sourceType: ClassroomSourceType, classType?: ClassroomType): string => {
	// Display text for Google provided classes need to specify whether they are a Classroom or a Group
	if (sourceType === ClassroomSourceType.Google) {
		if (classType === ClassroomType.Group) return "Google Group";
		if (classType === ClassroomType.Classroom) return "Google Classroom";
	}
	return providerDisplayText[sourceType as keyof typeof providerDisplayText] || "Uncategorised";
};

export const getProviderDisplayText2 = (sourceType: ClassroomSourceType | string, classType?: ClassroomType | string): string => {
	const s = sourceType.toLowerCase() as ClassroomSourceType;
	const t = classType?.toLowerCase() as ClassroomType;
	return getProviderDisplayText(s, t);
};
